import getFromLocalStorage from './local/get';
import getFromCookie from './cookie/get';
import parse from '../json/parse';
import { StoredLink } from '../link/type/StoredLink';

const f = (): StoredLink | null => {
    const link = getFromLocalStorage('share-link') || getFromCookie('share-link');

    return link ? parse<StoredLink>(link) : null;
};

export default f;
